export default __webpack_public_path__ + "static/media/deleteIcon.7f3cecec.svg";